import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { IEligibilityRouting } from '../../interfaces/eligibility-routing/eligibility-routing.interface';

@Injectable({
  providedIn: 'root',
})
export class EligibilityRoutingService {
  constructor(private http: HttpClient) {}

  createEligibilityRouting(
    eligibilityRouting: IEligibilityRouting,
  ): Observable<void> {
    return this.http
      .post<undefined>(
        `${getRestEndpoint()}/eligibility/routing`,
        eligibilityRouting,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }

  editEligibilityRouting(
    eligibilityRouting: IEligibilityRouting,
  ): Observable<void> {
    const { scId } = eligibilityRouting;
    const { groupId } = eligibilityRouting;
    return this.http
      .put<undefined>(
        `${getRestEndpoint()}/eligibility/routing/${scId}/${groupId}`,
        eligibilityRouting,
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            return error;
          });
        }),
      );
  }
}
